module.exports = __webpack_public_path__ + "static/media/Saunders_Diane-2022_edited-1.964213ed.jpg";